import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { QueryModelApiConfiguration } from '../apiConfiguration';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { ReferralsSearchFilter } from 'app/shared/models/queryModel/referrals-search-filter';

@Injectable()
export class ConsultationRequestSearchService extends ServiceBase {

    private actionUrl: string;
    private byFilter: string;
    private getOutPatientReferralSearchUrl: string;

    constructor(private _http: HttpClient, private _configuration: QueryModelApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.byFilter = this.actionUrl + _configuration.consultationRequesSearch.byFilter;
        this.getOutPatientReferralSearchUrl = this.actionUrl + _configuration.consultationRequesSearch.getOutPatientReferralSearch;
    }

    getConsultationRequestBySearch = (filter: any): Observable<any[]> => {
        const patientName = filter?.patientName || '';
        const sectionId = filter?.sectionId || '';
        const fromDoctorId = filter?.fromDoctorId || '';
        const toDoctorId = filter?.toDoctorId || '';
        const requestType = filter?.requestType || '';

        return this._http.get<any>(this.byFilter
            + '?Patient_Name=' + patientName
            + '&Section_Id=' + sectionId
            + '&From_Doctor_Id=' + fromDoctorId
            + '&To_Doctor_Id=' + toDoctorId
            + '&Request_Type=' + requestType
        );
    }

    getOutPatientReferralSearch = (filter: ReferralsSearchFilter): Observable<any[]> => {
        const patientCode = filter?.PatientCode || '';
        const patientName = filter?.PatientName || '';
        const encounterDate = filter?.EncounterDate ? new Date(filter?.EncounterDate).toLocaleDateString()  : '';
        const requestBy = filter?.RequestBy || '';
        const requestDate = filter?.RequestDate ? new Date(filter?.RequestDate).toLocaleDateString() : '';
        const speciality = filter?.Speciality || '';
        const doctor = filter?.Doctor || '';
        const status = filter?.Status || '';
        const pageIndex = filter?.PageIndex;
        const pageSize = filter?.PageSize;

        return this._http.get<any>(this.getOutPatientReferralSearchUrl
            + '?PATIENT_CODE=' + patientCode
            + '&PATIENT_NAME=' + patientName
            + '&ENCOUNTER_DATE=' + encounterDate
            + '&REQUEST_BY=' + requestBy
            + '&REQUEST_DATE=' + requestDate
            + '&SPECIALITY=' + speciality
            + '&DOCTOR=' + doctor
            + '&STATUS=' + status
            + '&PAGE_INDEX=' + pageIndex
            + '&PAGE_SIZE=' + pageSize
        );
    }
}

